import i18n from 'i18next';
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    // we init with resources
    resources: {
      en: {
        translations: {
          "Cryptocurrencies": "Cryptocurrencies",
          "Markets": "Markets",
          "Market Cap": "Market Cap",
          "24h Vol": "24h Vol",
          "BTC Dominance": "BTC Dominance",
          "Advertise": "Advertise",
          "Get Started": "Get Started",
          "Wallet": "Wallet",
          "Mining": "Mining",
          "News": "News",
          "Exchange": "Exchange",
          "Casino Games": "Casino Games",
          "Buy Bitcoin": "Buy Bitcoin",
          "All": "All",
          "Coins": "Coins",
          "Tokens": "Tokens",
          "Featured": "Featured",
          "Exchanges": "Exchanges",
          "Gainers and Losers": "Gainers and Losers",
          "All Currencies": "All Currencies",
          "Favourites": "Favourites",
          "Cryptocurrency": "Cryptocurrency",
          "Price": "Price",
          "Price Graph (7D)": "Price Graph (7D)",
          "24hr Volume": "24hr Volume",
          "Action": "Action",
          "Buy": "Buy",
          "Trade": "Trade",
          "Earn": "Earn",
          "Latest News": "Latest News",
          "Load More": "Load More",
          "Read More": "Read More",
          "by": "by",
          "Biggest Gainers 24H": "Biggest Gainers 24H",
          "Biggest Losers 24H": "Biggest Losers 24H",
          "Name": "Name",
          "24hr Vol": "24hr Vol",
          "Quick Stats": "Quick Stats",
          "Bitcoin Price": "Bitcoin Price",
          "Market Cap Rank": "Market Cap Rank",
          "More details": "More details",
          "Back to Markets": "Back to Markets",
          "Stats": "Stats",
          "Rank": "Rank",
          "Meta": "Meta",
          "Algorithm": "Algorithm",
          "Proof Type": "Proof Type",
          "Supply": "Supply",
          "Max Supply": "Max Supply",
          "Token Summary": "Token Summary",
          "Top": "Top",
          "Products & Services": "Products & Services",
          "Get Bitcoin": "Get Bitcoin",
          "Follow": "Follow",
          "Company": "Company",
          "Mint": "Mint",
          "Bitcoin Cash Register": "Bitcoin Cash Register",
          "Merchant Solutions": "Merchant Solutions",
          "Developers": "Developers",
          "Free Bitcoin Cash": "Free Bitcoin Cash",
          "Trade Locally": "Trade Locally",
          "Earn Bitcoin": "Earn Bitcoin",
          "Spend Bitcoin": "Spend Bitcoin",
          "Bitcoin Cash Map": "Bitcoin Cash Map",
          "Games": "Games",
          "News Telegram": "News Telegram",
          "YouTube": "YouTube",
          "Instagram": "Instagram",
          "Twitter": "Twitter",
          "Forum": "Forum",
          "Reddit": "Reddit",
          "Podcasts": "Podcasts",
          "Facebook": "Facebook",
          "About": "About",
          "Press & Media": "Press & Media",
          "Events": "Events",
          "Careers": "Careers",
          "Freedom": "Freedom",
          "Blog": "Blog",
          "Contact": "Contact",
          "Partners": "Partners",
          "Support": "Support",
          "Search By Name": "Search By Name",
          "All rights reserved": "All rights reserved",
          "Privacy Policy": "Privacy Policy",
          "Terms of Use": "Terms of Use",
          "Sitemap": "Sitemap",
          "IN": "In",
          "AT": "At",
          "OUT": "Out",
          "Holders Making Money at Current Price": "Holders Making Money at Current Price",
          "Interesting on-chain metrics that provide a rapid understanding": "Interesting on-chain metrics that provide a rapid understanding",
          "Top List": "Top List",      
          "Pairs": "Pairs",      
          "All Exchanges": "All Exchanges",      
          "Fiat currencies": "Fiat currencies",     
          "Website": "Website",     
          "Fees": "Fees",     
          "Link": "Link",     
          "Chat": "Chat",     
          "Tweet": "Tweet",     
          "Back to Exchange": "Back to Exchange",  
          "Sell Bitcoin": "Sell Bitcoin",  
          "Block Explorer": "Block Explorer",  
          "Join our community in social networks": "Join our community in social networks",  
          "Fresh news, events, and insights around the crypto world": "Fresh news, events, and insights around the crypto world",  
          "Subscribe to your": "Subscribe to your",  
          "Newsletter": "Newsletter",  
          "Subscribe": "Subscribe", 
        }
      },
      sp: {
        translations: {
          "Cryptocurrencies": "CRIPTOMONEDAS",
          "Markets": "Mercados",
          "Market Cap": "Tapa del mercado",
          "24h Vol": "Vol de 24 horas",
          "BTC Dominance": "Dominio de BTC",
          "Advertise": "Anunciar",
          "Get Started": "Empezar",
          "Wallet": "Billetera",
          "Mining": "Minería",
          "News": "Noticias",
          "Exchange": "Intercambiar",
          "Casino Games": "Juegos de casino",
          "Buy Bitcoin": "Comprar Bitcoin",
          "All": "Todos",
          "Coins": "Monedas",
          "Tokens": "Simbólico",
          "Featured": "Destacadas",
          "Exchanges": "Intercambios",
          "Gainers and Losers": "Ganadores y perdedores",
          "All Currencies": "Todas las monedas",
          "Favourites": "Favoritas",
          "Cryptocurrency": "Criptomoneda",
          "Price": "Precio",
          "Price Graph (7D)": "Gráfico de precios (7D)",
          "24hr Volume": "Volumen de 24 horas",
          "Action": "Acción",
          "Buy": "Comprar",
          "Trade": "Comercio",
          "Earn": "Ganar",
          "Latest News": "Últimas noticias",
          "Load More": "Carga más",
          "Read More": "Lee mas",
          "by": "por",
          "Biggest Gainers 24H": "Mayores ganadores 24H",
          "Biggest Losers 24H": "Los mayores perdedores 24H",
          "Name": "Nombre",
          "24hr Vol": "Vol de 24 horas",
          "Quick Stats": "Estadísticas rápidas",
          "Bitcoin Price": "Precio de Bitcoin",
          "Market Cap Rank": "Rango de capitalización de mercado",
          "More details": "Más detalles",
          "Back to Markets": "Volver a Mercados",
          "Stats": "Estadísticas",
          "Rank": "Rango",
          "Meta": "Meta",
          "Algorithm": "Algoritmo",
          "Proof Type": "Tipo de prueba",
          "Supply": "Suministro",
          "Max Supply": "Suministro máximo",
          "Token Summary": "Resumen de tokens",
          "Top": "Parte superior",
          "Products & Services": "productos y servicios",
          "Get Bitcoin": "Obtener Bitcoin",
          "Follow": "Seguir",
          "Company": "Empresa",
          "Mint": "menta",
          "Bitcoin Cash Register": "Caja registradora de Bitcoin",
          "Merchant Solutions": "Soluciones comerciales",
          "Developers": "Desarrolladores",
          "Free Bitcoin Cash": "Bitcoin Cash gratis",
          "Trade Locally": "Comercio local",
          "Earn Bitcoin": "Gana Bitcoin",
          "Spend Bitcoin": "Gastar Bitcoin",
          "Bitcoin Cash Map": "Mapa de Bitcoin Cash",
          "Games": "Juegos",
          "News Telegram": "Telegrama de noticias",
          "YouTube": "YouTube",
          "Instagram": "Instagram",
          "Twitter": "Twitter",
          "Forum": "Foro",
          "Reddit": "Reddit",
          "Podcasts": "Podcasts",
          "Facebook": "Facebook",
          "About": "Acerca de",
          "Press & Media": "Prensa y medios",
          "Events": "Eventos",
          "Careers": "Carreras",
          "Freedom": "Libertad",
          "Blog": "Blog",
          "Contact": "Contacto",
          "Partners": "Socios",
          "Support": "Apoyo",
          "Search By Name": "Buscar por nombre",
          "All rights reserved": "Todos los derechos reservados",
          "Privacy Policy": "Política de privacidad",
          "Terms of Use": "Términos de Uso",
          "Sitemap": "Mapa del sitio",
          "Interesting on-chain metrics that provide a rapid understanding": "Métricas interesantes en la cadena que proporcionan una comprensión rápida",
          "IN": "En",
          "AT": "A",
          "OUT": "Fuera",
          "Holders Making Money at Current Price": "Titulares que ganan dinero a precio actual",
          "Top List": "Lista superior",      
          "Pairs": "Pares",      
          "All Exchanges": "Todos los intercambios",      
          "Fiat currencies": "Monedas fiduciarias", 
          "Website": "Sitio web",     
          "Fees": "Tarifa",      
          "Link": "Enlace",     
          "Chat": "Charla",     
          "Tweet": "Pío",
          "Back to Exchange": "Volver a Exchange",  
          "Sell Bitcoin": "Vender Bitcoin", 
          "Block Explorer": "Explorador de bloques",  

          "Join our community in social networks": "Únete a nuestra comunidad en redes sociales",  
          "Fresh news, events, and insights around the crypto world": "Nuevas noticias, eventos y conocimientos sobre el mundo de las criptomonedas",  
          "Subscribe to your": "Suscríbete a tu",  
          "Newsletter": "Boletin informativo",  
          "Subscribe": "Suscribir", 
        }
      },
      fr: {
        translations: {
          "Cryptocurrencies": "Cryptomonnaies",
          "Markets": "Les marchés",
          "Market Cap": "Capitalisation boursière",
          "24h Vol": "Volume 24 heures",
          "BTC Dominance": "Dominance BTC",
          "Advertise": "Afficher",
          "Get Started": "Commencer",
          "Wallet": "Portefeuille",
          "Mining": "Exploitation minière",
          "News": "Nouvelles",
          "Exchange": "Échange",
          "Casino Games": "Jeux de casino",
          "Buy Bitcoin": "Acheter Bitcoin",
          "All": "Tout",
          "Coins": "Pièces de monnaie",
          "Tokens": "Jetons",
          "Featured": "En vedette",
          "Exchanges": "des échanges",
          "Gainers and Losers": "Gagnants et perdants",
          "All Currencies": "Toutes les devises",
          "Favourites": "Favoris",
          "Cryptocurrency": "Cryptomonnaie",
          "Price": "Prix",
          "Price Graph (7D)": "Graphique des prix (7D)",
          "24hr Volume": "Volume 24 heures",
          "Action": "Action",
          "Buy": "Acheter",
          "Trade": "Commerce",
          "Earn": "Gagner",
          "Latest News": "Dernières nouvelles",
          "Load More": "Charger plus",
          "Read More": "Lire la suite",
          "by": "par",
          "Biggest Gainers 24H": "Les plus grands gagnants 24H",
          "Biggest Losers 24H": "Les plus gros perdants 24H",
          "Name": "Nom",
          "24hr Vol": "Volume 24 heures",
          "Quick Stats": "Statistiques rapides",
          "Bitcoin Price": "Prix ​​Bitcoin",
          "Market Cap Rank": "Classement de la capitalisation boursière",
          "More details": "Plus de détails",
          "Back to Markets": "Retour aux marchés",
          "Stats": "Statistiques",
          "Rank": "Rang",
          "Meta": "Meta",
          "Algorithm": "Algorithme",
          "Proof Type": "Type de preuve",
          "Supply": "La fourniture",
          "Max Supply": "Offre maximale",
          "Token Summary": "Résumé des jetons",
          "Top": "Haut",
          "Products & Services": "Produits",
          "Get Bitcoin": "Obtenez Bitcoin",
          "Follow": "Suivre",
          "Company": "Compagnie",
          "Mint": "menthe",
          "Bitcoin Cash Register": "Caisse enregistreuse Bitcoin",
          "Merchant Solutions": "Solutions marchandes",
          "Developers": "Développeurs",
          "Free Bitcoin Cash": "Bitcoin Cash gratuit",
          "Trade Locally": "Commerce local",
          "Earn Bitcoin": "Gagnez du Bitcoin",
          "Spend Bitcoin": "Dépensez Bitcoin",
          "Bitcoin Cash Map": "Carte Bitcoin Cash",
          "Games": "Jeux",
          "News Telegram": "Télégramme de nouvelles",
          "YouTube": "YouTube",
          "Instagram": "Instagram",
          "Twitter": "Twitter",
          "Forum": "Forum",
          "Reddit": "Reddit",
          "Podcasts": "Podcasts",
          "Facebook": "Facebook",
          "About": "Sur",
          "Press & Media": "Presse et médias",
          "Events": "Événements",
          "Careers": "Carrières",
          "Freedom": "Liberté",
          "Blog": "Blog",
          "Contact": "Contact",
          "Partners": "Les partenaires",
          "Support": "Soutien",
          "Search By Name": "Recherche par nom",
          "All rights reserved": "Tous les droits sont réservés",
          "Privacy Policy": "Politique de confidentialité",
          "Terms of Use": "Conditions d'utilisation",
          "Sitemap": "Plan du site",
          "Interesting on-chain metrics that provide a rapid understanding": "Des métriques en chaîne intéressantes qui permettent une compréhension rapide",
          "IN": "Dans",
          "AT": "À",
          "OUT": "En dehors",
          "Holders Making Money at Current Price": "Les détenteurs gagnent de l'argent au prix actuel",
          "Top List": "Top liste",      
          "Pairs": "Paires",      
          "All Exchanges": "Tous les échanges",      
          "Fiat currencies": "Devises Fiat", 
          "Website": "Site Internet",     
          "Fees": "Honoraires",  
          "Link": "Lien",     
          "Chat": "Bavarder",     
          "Tweet": "Tweet",
          "Back to Exchange": "Retour à l'échange",
          "Sell Bitcoin": "Vendre du Bitcoin", 
          "Block Explorer": "Explorateur de blocs",    

          "Join our community in social networks": "Rejoignez notre communauté sur les réseaux sociaux",  
          "Fresh news, events, and insights around the crypto world": "Nouvelles, événements et idées fraîches dans le monde de la cryptographie",  
          "Subscribe to your": "Abonnez-vous à votre",  
          "Newsletter": "Bulletin",  
          "Subscribe": "Souscrire", 
        }
      },
      it: {
        translations: {
          "Cryptocurrencies": "Criptovalute",
          "Markets": "Mercati",
          "Market Cap": "Capitalizzazione di mercato",
          "24h Vol": "Volume 24 ore",
          "BTC Dominance": "BTC Dominanza",
          "Advertise": "Pubblicizza",
          "Get Started": "Iniziare",
          "Wallet": "Portafoglio",
          "Mining": "Estrazione",
          "News": "notizia",
          "Exchange": "Scambio",
          "Casino Games": "Giochi da casinò",
          "Buy Bitcoin": "Acquista Bitcoin",
          "All": "Tutti",
          "Coins": "Monete",
          "Tokens": "Gettoni",
          "Featured": "In primo piano",
          "Exchanges": "Scambi",
          "Gainers and Losers": "Vincitori e perdenti",
          "All Currencies": "Tutte le valute",
          "Favourites": "Preferiti",
          "Cryptocurrency": "Criptovaluta",
          "Price": "Prezzo",
          "Price Graph (7D)": "Grafico dei prezzi (7D)",
          "24hr Volume": "Volume 24 ore",
          "Action": "Azione",
          "Buy": "Acquistare",
          "Trade": "Commercio",
          "Earn": "Guadagnare",
          "Latest News": "Ultime notizie",
          "Load More": "Carica altro",
          "Read More": "Leggi di più",
          "by": "di",
          "Biggest Gainers 24H": "I più grandi guadagni 24 ore",
          "Biggest Losers 24H": "I più grandi perdenti 24 ore",
          "Name": "Nome",
          "24hr Vol": "Volume 24 ore",
          "Quick Stats": "Statistiche rapide",
          "Bitcoin Price": "Prezzo Bitcoin",
          "Market Cap Rank": "Classifica capitalizzazione di mercato",
          "More details": "Più dettagli",
          "Back to Markets": "Torna ai mercati",
          "Stats": "Statistiche",
          "Rank": "Rango",
          "Meta": "Meta",
          "Algorithm": "Algoritmo",
          "Proof Type": "Tipo di prova",
          "Supply": "Fornitura",
          "Max Supply": "Fornitura massima",
          "Token Summary": "Riepilogo token",
          "Top": "Superiore",
          "Products & Services": "prodotti e servizi",
          "Get Bitcoin": "Ottieni Bitcoin",
          "Follow": "Seguire",
          "Company": "Azienda",
          "Mint": "menta",
          "Bitcoin Cash Register": "Registratore di cassa Bitcoin",
          "Merchant Solutions": "Soluzioni per commercianti",
          "Developers": "Sviluppatori",
          "Free Bitcoin Cash": "Bitcoin Cash gratuito",
          "Trade Locally": "Commercio locale",
          "Earn Bitcoin": "Guadagna Bitcoin",
          "Spend Bitcoin": "Spendi Bitcoin",
          "Bitcoin Cash Map": "Bitcoin denaro contante Carta geografica",
          "Games": "Giochi",
          "News Telegram": "Telegram di notizie",
          "YouTube": "YouTube",
          "Instagram": "Instagram",
          "Twitter": "Twitter",
          "Forum": "Forum",
          "Reddit": "Reddit",
          "Podcasts": "Podcasts",
          "Facebook": "Facebook",
          "About": "Di",
          "Press & Media": "Stampa",
          "Events": "Eventi",
          "Careers": "Carriere",
          "Freedom": "La libertà",
          "Blog": "Blog",
          "Contact": "Contatto",
          "Partners": "Partners",
          "Support": "Supporto",
          "Search By Name": "Ricerca per nome",
          "All rights reserved": "Tutti i diritti riservati",
          "Privacy Policy": "politica sulla riservatezza",
          "Terms of Use": "Condizioni d'uso",
          "Sitemap": "Mappa del sito",
          "Interesting on-chain metrics that provide a rapid understanding of the state of Tether": "Metriche interessanti sulla catena che forniscono una rapida comprensione",        
          "IN": "Nel",
          "AT": "A",
          "OUT": "Su",
          "Holders Making Money at Current Price": "Titolari che fanno soldi al prezzo corrente",
          "Top List": "Top liste",      
          "Pairs": "Coppie",      
          "All Exchanges": "Tutti gli scambi",      
          "Fiat currencies": "Valute Fiat",  
          "Website": "Sito web",     
          "Fees": "Commissioni",  
          "Link": "Link",     
          "Chat": "Chiacchierare",     
          "Tweet": "Tweet",
          "Back to Exchange": "Torna a Exchange",  
          "Sell Bitcoin": "Vendi Bitcoin",  
          "Block Explorer": "Block Explorer",    

          "Join our community in social networks": "Unisciti alla nostra comunità nei social network",  
          "Fresh news, events, and insights around the crypto world": "Notizie fresche, eventi e approfondimenti in tutto il mondo crittografico",
          "Subscribe to your": "Iscriviti al tuo",  
          "Newsletter": "Newsletter",  
          "Subscribe": "sottoscrivi",  
        }
      },
      de: {
        translations: {
          "Cryptocurrencies": "Crypto-valuta's",
          "Markets": "Markten",
          "Market Cap": "Marktkapitalisatie",
          "24h Vol": "24 uur Vol",
          "BTC Dominance": "BTC-dominantie",
          "Advertise": "Reclame maken",
          "Get Started": "Begin",
          "Wallet": "Portemonnee",
          "Mining": "Mijnbouw",
          "News": "Nieuws",
          "Exchange": "Uitwisseling",
          "Casino Games": "Casino spellen",
          "Buy Bitcoin": "Koop Bitcoin",
          "All": "Allemaal",
          "Coins": "Munten",
          "Tokens": "Munten",
          "Featured": "Uitgelicht",
          "Exchanges": "Uitwisselingen",
          "Gainers and Losers": "Stijgers en verliezers",
          "All Currencies": "Alle valuta",
          "Favourites": "Favorieten",
          "Cryptocurrency": "Cryptogeld",
          "Price": "Prijs",
          "Price Graph (7D)": "Prijsgrafiek (7D)",
          "24hr Volume": "24-uurs volume",
          "Action": "Actie",
          "Buy": "Kopen",
          "Trade": "Handel",
          "Earn": "Verdienen",
          "Latest News": "Laatste nieuws",
          "Load More": "Meer laden",
          "Read More": "Lees verder",
          "by": "door",
          "Biggest Gainers 24H": "Grootste winst 24 uur",
          "Biggest Losers 24H": "Grootste verliezers 24H",
          "Name": "Naam",
          "24hr Vol": "24 uur Vol",
          "Quick Stats": "Snelle statistieken",
          "Bitcoin Price": "Bitcoin-prijs",
          "Market Cap Rank": "Marktkapitalisatie",
          "More details": "Meer details",
          "Back to Markets": "Terug naar markten",
          "Stats": "Statistieken",
          "Rank": "Rang",
          "Meta": "Meta",
          "Algorithm": "Algoritme",
          "Proof Type": "Bewijs type",
          "Supply": "Levering",
          "Max Supply": "Max. Aanbod",
          "Token Summary": "Token Samenvatting",
          "Top": "Top",
          "Products & Services": "producten en diensten",
          "Get Bitcoin": "Koop Bitcoin",
          "Follow": "Volgen",
          "Company": "Bedrijf",
          "Mint": "Munt",
          "Bitcoin Cash Register": "Bitcoin-kassa",
          "Merchant Solutions": "Merchant-oplossingen",
          "Developers": "Ontwikkelaars",
          "Free Bitcoin Cash": "Gratis Bitcoin Cash",
          "Trade Locally": "Handel lokaal",
          "Earn Bitcoin": "Verdien Bitcoin",
          "Spend Bitcoin": "Geef Bitcoin uit",
          "Bitcoin Cash Map": "Bitcoin Cash-kaart",
          "Games": "Spellen",
          "News Telegram": "Nieuws Telegram",
          "YouTube": "YouTube",
          "Instagram": "Instagram",
          "Twitter": "Twitter",
          "Forum": "Forum",
          "Reddit": "Reddit",
          "Podcasts": "Podcasts",
          "Facebook": "Facebook",
          "About": "Over",
          "Press & Media": "Pers & Media",
          "Events": "Evenementen",
          "Careers": "Carrières",
          "Freedom": "Vrijheid",
          "Blog": "Blog",
          "Contact": "Contatto",
          "Partners": "Partners",
          "Support": "Ondersteuning",
          "Search By Name": "Zoek op naam",
          "All rights reserved": "Alle rechten voorbehouden",
          "Privacy Policy": "Privacybeleid",
          "Terms of Use": "Gebruiksvoorwaarden",
          "Sitemap": "Sitemap",
          "Interesting on-chain metrics that provide a rapid understanding of the state of Tether": "Interessante on-chain metrics die een snel inzicht geven in de staat van Tether",        
          "IN": "Nel",
          "AT": "BIJ",
          "OUT": "UIT",
          "Holders Making Money at Current Price": "Houders die geld verdienen tegen de huidige prijs",
          "Top List": "Toplijst",      
          "Pairs": "Paren",      
          "All Exchanges": "Alle uitwisselingen",      
          "Fiat currencies": "Fiat-valuta's",  
          "Website": "Website",     
          "Fees": "Vergoedingen",  
          "Link": "Koppeling",     
          "Chat": "Chiacchierare",     
          "Tweet": "Tweet",
          "Back to Exchange": "Terug naar Exchange",  
          "Sell Bitcoin": "Verkoop Bitcoin",  
          "Block Explorer": "Blokkeer Explorer",     

          "Join our community in social networks": "Word lid van onze gemeenschap op sociale netwerken",  
          "Fresh news, events, and insights around the crypto world": "Vers nieuws, evenementen en inzichten over de cryptowereld",
          "Subscribe to your": "Abonneer u op uw",  
          "Newsletter": "Nieuwsbrief",  
          "Subscribe": "Abonneren", 
        }
      }
    },
    fallbackLng: 'en',
    debug: false,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ','
    },

    react: {
      wait: true
    }
  });

export default i18n;